function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "097 368 07 88") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M49 28.12h24.85a7.7 7.7 0 0 1 7.7 7.7v51.24a7.7 7.7 0 0 1-7.7 7.7H49a7.7 7.7 0 0 1-7.7-7.7V35.81a7.68 7.68 0 0 1 7.7-7.69ZM61.44 0A61.46 61.46 0 1 1 18 18 61.23 61.23 0 0 1 61.44 0Zm38 23.45a53.72 53.72 0 1 0 15.74 38 53.56 53.56 0 0 0-15.74-38ZM44.75 84.07h33.37V36.52H44.75v47.55Zm16.68 2.41a3.17 3.17 0 1 1-3.17 3.16 3.16 3.16 0 0 1 3.17-3.16Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.01d52330c48b6cd25c5818d00db2e763.svg";
export { ForwardRef as ReactComponent };